export const MARK_AS_COMPLETE = `[MARK_AS_COMPLETE] marked as complete!!`;
export const UPLOAD_CODE_SOLUTION = `[UPLOAD_CODE_SOLUTION] add source code!!`;

export const SET_AS_EASY_QUESTION = `[SET_AS_EASY_QUESTION] set as EASY level`;
export const SET_AS_MEDIUM_QUESTION = `[SET_AS_MEDIUM_QUESTION] set as MEDIUM level`;
export const SET_AS_HARD_QUESTION = `[SET_AS_HARD_QUESTION] set as HARD level`;
export const ON_INITIAL_LOAD = `[ON_INITIAL_LOAD] populated customed-lists`;